// extracted by mini-css-extract-plugin
export var boxItems = "_7g-1";
export var boxItemsLg = "_7g-2";
export var button = "_7g-7";
export var buttonHoverless = "_7g-9";
export var buttonLg = "_7g-8";
export var filterGroupBox = "_7g-0";
export var icon = "_7g-3";
export var iconSecondary = "_7g-6";
export var iconWrapper = "_7g-4";
export var iconWrapperLg = "_7g-5";
export var truncatedLabel = "_7g-a";